import React from 'react';
import styled from 'styled-components';
import Header from './header';
import RiskHistory from './riskHistory';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #C8C8C8;
  padding: 21px 28px;
  border-radius: 4px;

  &.active {
    border-color: var(--mmt-primary-70);
  }
`;

export default function Year({
  opened = false,
  data = {},
  isCurrent = false,
  onToggle = () => { },
  nextYear = null,
  descriptions = {},
  riskMitigationMeasures = [],
  associatedEvents = {
    incidents: [],
    mitigationActions: [],
    other: [],
  },
  canEdit = false,
}) {
  return (
    <Style
      className={opened ? 'active' : 'none'}
    >
      <Header
        data={data}
        opened={opened}
        onToggle={onToggle}
        nextYear={nextYear}
        isCurrent={isCurrent}
      />
      {opened && (
        <RiskHistory
          canEdit={canEdit}
          data={{
            ...data,
            descriptions,
            riskMitigationMeasures,
            associatedEvents,
          }}
        />
      )}
    </Style>
  );
}
